var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"LoadDataCom"},_vm._l((_vm.loadList),function(v,i){return _c('li',{key:i,style:({
      background: _vm.EchartsLightColor[i],
    })},[_c('h4',[_vm._v(_vm._s(v.value))]),_c('p',[_vm._v(" "+_vm._s(v.display)+" "),_c('span',[_vm._v(_vm._s(v.unit))])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }